export default __webpack_public_path__ + "static/media/lmsCertificate.9c0f0ce8.webp";